function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { getCurrentHub } from '@sentry/browser';
import { logger, timestampInSeconds } from '@sentry/utils';
import { formatComponentName } from './components.js';
import { DEFAULT_HOOKS } from './constants.js';
var VUE_OP = 'ui.vue'; // Mappings from operation to corresponding lifecycle hook.

var HOOKS = {
  activate: ['activated', 'deactivated'],
  create: ['beforeCreate', 'created'],
  destroy: ['beforeDestroy', 'destroyed'],
  mount: ['beforeMount', 'mounted'],
  update: ['beforeUpdate', 'updated']
};
/** Grabs active transaction off scope, if any */

function getActiveTransaction() {
  var scope = getCurrentHub().getScope();
  return scope && scope.getTransaction();
}
/** Finish top-level span and activity with a debounce configured using `timeout` option */


function finishRootSpan(vm, timestamp, timeout) {
  if (vm.$_sentryRootSpanTimer) {
    clearTimeout(vm.$_sentryRootSpanTimer);
  }

  vm.$_sentryRootSpanTimer = setTimeout(function () {
    if (vm.$root && vm.$root.$_sentryRootSpan) {
      vm.$root.$_sentryRootSpan.finish(timestamp);
      vm.$root.$_sentryRootSpan = undefined;
    }
  }, timeout);
}

var createTracingMixins = function createTracingMixins(options) {
  var hooks = (options.hooks || []).concat(DEFAULT_HOOKS) // Removing potential duplicates
  .filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
  var mixins = {};

  var _iterator = _createForOfIteratorHelper(hooks),
      _step;

  try {
    var _loop = function _loop() {
      var operation = _step.value;
      // Retrieve corresponding hooks from Vue lifecycle.
      // eg. mount => ['beforeMount', 'mounted']
      var internalHooks = HOOKS[operation];

      if (!internalHooks) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn("Unknown hook: ".concat(operation));
        return "continue";
      }

      var _iterator2 = _createForOfIteratorHelper(internalHooks),
          _step2;

      try {
        var _loop2 = function _loop2() {
          var internalHook = _step2.value;

          mixins[internalHook] = function () {
            var isRoot = this.$root === this;

            if (isRoot) {
              var activeTransaction = getActiveTransaction();

              if (activeTransaction) {
                this.$_sentryRootSpan = this.$_sentryRootSpan || activeTransaction.startChild({
                  description: 'Application Render',
                  op: "".concat(VUE_OP, ".render")
                });
              }
            } // Skip components that we don't want to track to minimize the noise and give a more granular control to the user


            var name = formatComponentName(this, false);
            var shouldTrack = Array.isArray(options.trackComponents) ? options.trackComponents.indexOf(name) > -1 : options.trackComponents; // We always want to track root component

            if (!isRoot && !shouldTrack) {
              return;
            }

            this.$_sentrySpans = this.$_sentrySpans || {}; // Start a new span if current hook is a 'before' hook.
            // Otherwise, retrieve the current span and finish it.

            if (internalHook == internalHooks[0]) {
              var _activeTransaction = this.$root && this.$root.$_sentryRootSpan || getActiveTransaction();

              if (_activeTransaction) {
                // Cancel old span for this hook operation in case it didn't get cleaned up. We're not actually sure if it
                // will ever be the case that cleanup hooks re not called, but we had users report that spans didn't get
                // finished so we finish the span before starting a new one, just to be sure.
                var oldSpan = this.$_sentrySpans[operation];

                if (oldSpan && !oldSpan.endTimestamp) {
                  oldSpan.finish();
                }

                this.$_sentrySpans[operation] = _activeTransaction.startChild({
                  description: "Vue <".concat(name, ">"),
                  op: "".concat(VUE_OP, ".").concat(operation)
                });
              }
            } else {
              // The span should already be added via the first handler call (in the 'before' hook)
              var span = this.$_sentrySpans[operation]; // The before hook did not start the tracking span, so the span was not added.
              // This is probably because it happened before there is an active transaction

              if (!span) return;
              span.finish();
              finishRootSpan(this, timestampInSeconds(), options.timeout);
            }
          };
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return mixins;
};

export { createTracingMixins, getActiveTransaction };